import { DataGrid } from "@mui/x-data-grid";
import { autoSizeOptionsForDataGrid } from "constants/componentsConstants";
import { dataGridState } from "constants/dataGridConstants";
const style = {
  "& .row--Error": {
    backgroundColor: "#FFCDD2 !important",
  },
  "& .row--Warning": {
    backgroundColor: "#FFF9C4 !important",
  },
  "& .row--Info": {
    backgroundColor: "#BBDEFB !important",
  },
  "& .MuiDataGrid-row:hover": { filter: "brightness(0.9)" },
  "& .MuiDataGrid-row.Mui-selected": { filter: "brightness(0.9)" },
};
export const DataGridWithHighlightClass = ({ ...props }) => {
  return (
    <DataGrid
      sx={style}
      {...props}
      autosizeOptions={autoSizeOptionsForDataGrid}
      initialState={dataGridState.initialState}
      pageSizeOptions={dataGridState.pageSizeOptions}
      autoHeight
      autosizeOnMount
      getRowHeight={() => "auto"}
    />
  );
};
